import {
    useEffect
} from "react";

import {
    refreshAuthentication
} from "../services/auth";

const AuthBootstrap: React.FC = () => {
    useEffect(function () {
        void refreshAuthentication()
            .catch(function (error: unknown) {
                /*
                    No cerrar sesión local por un error temporal
                    de red o por un backend momentáneamente caído.
                */
                console.warn(
                    "No fue posible validar la sesión inicial:",
                    error
                );
            });
    }, []);

    return null;
};

export default AuthBootstrap;